import { IService } from "@/model/Service/Service"
import ParticipantService, { IParticipantService } from "@/model/Service/ParticipantService"
import AccomodationService from "@/model/Service/AccomodationService"
import GlobalService from "@/model/Service/GlobalService"
import { IServiceFamily } from "@/model/ServiceFamily/ServiceFamily"
import AccomodationServiceFamily from "@/model/ServiceFamily/AccomodationServiceFamily"
import ParticipantServiceFamily from "@/model/ServiceFamily/ParticipantServiceFamily"
import GlobalServiceFamily from "@/model/ServiceFamily/GlobalServiceFamily"
import ServiceContentFactory from "@/model/Content/ServiceContentFactory"
import { IServiceContent } from "@/model/Content/ServiceContent"

import { ServiceContent, ServicePrice, ServiceQuote, ServiceQuoteTravellerData } from "@requests"




export interface IServiceFactory { }


class ServiceFactory implements IServiceFactory {

    public static createService(
        priceObj: ServicePrice | undefined,
        quoteObj: ServiceQuote,
        contentObj: ServiceContent,
        serviceFamily: IServiceFamily
    ): IService {
        // create content object
        // console.log('contentObj: ', contentObj)
        // console.log('serviceFamily: ', serviceFamily)
        const serviceContent: IServiceContent = ServiceContentFactory.createServiceContent(contentObj, serviceFamily)
        if (serviceFamily instanceof AccomodationServiceFamily) return ServiceFactory.createAccomodationService(priceObj, quoteObj, serviceContent)
        if (serviceFamily instanceof ParticipantServiceFamily) return ServiceFactory.createParticipantService(priceObj, quoteObj, serviceContent)
        if (serviceFamily instanceof GlobalServiceFamily) return ServiceFactory.createGlobalService(priceObj, quoteObj, serviceContent)
        throw new Error(`serviceFamily type of ${serviceFamily.constructor.name} is not supported`)
    }


    private static createAccomodationService(
        priceObj: ServicePrice | undefined,
        quoteObj: ServiceQuote,
        serviceContent: IServiceContent,
    ) {
        const service = new AccomodationService(
            quoteObj.quantityMin,
            quoteObj.quantityMax,
            quoteObj.quantitySelected,
            quoteObj.price,
            quoteObj.id,
            quoteObj.quantity,
            quoteObj.startDate,
            quoteObj.endDate,
        )
        service.setBaseServiceQuoteObject(quoteObj)
        service.setServiceContent(serviceContent)
        const anyCrossPrice = priceObj && Object.values(priceObj.publicPriceByAge)[0]
        anyCrossPrice && service.setCrossPrice((anyCrossPrice as number) * 100)
        if (quoteObj.included) service.setIncluded(quoteObj.included)
        if (quoteObj.price) service.setTotalPrice(quoteObj.totalPrice || 0)
        serviceContent.setService(service)
        return service
    }


    private static createParticipantService(
        priceObj: ServicePrice | undefined,
        quoteObj: ServiceQuote,
        serviceContent: IServiceContent,
    ) {
        const service: IParticipantService = new ParticipantService(
            quoteObj.id,
            quoteObj.quantity,
            quoteObj.startDate,
            quoteObj.endDate,
        )
        priceObj && ServiceFactory.fillCrossPricesByAge(service, priceObj)
        ServiceFactory.fillTotalPricesByTravellerId(service, quoteObj)
        service.setBaseServiceQuoteObject(quoteObj)
        service.setServiceContent(serviceContent)
        serviceContent.setService(service)
        quoteObj.travellers && service.setQuoteTravellers(quoteObj.travellers)
        return service
    }


    private static createGlobalService(
        priceObj: ServicePrice | undefined,
        quoteObj: ServiceQuote,
        serviceContent: IServiceContent,
    ) {
        const service = new GlobalService(
            quoteObj.selected,
            quoteObj.included,
            quoteObj.id,
            quoteObj.quantity,
            quoteObj.startDate,
            quoteObj.endDate,
        )
        quoteObj.totalPrice && service.setTotalPrice(quoteObj.totalPrice)
        service.setBaseServiceQuoteObject(quoteObj)
        service.setServiceContent(serviceContent)
        serviceContent.setService(service)
        return service
    }


    private static fillCrossPricesByAge(service: IParticipantService, priceObj: ServicePrice | undefined) {
        if (priceObj && !priceObj.publicPriceByAge) {
            // console.log(`<<< DATADOG >>> - service with id ${service.getIdFull()} didn't have public price`)
            return
        }
        if (!priceObj) return
        // if (Object.entries(priceObj.publicPriceByAge).length === 0) console.log(`<<< DATADOG >>> - service with id ${service.getIdFull()} didn't have public price`)
        priceObj && Object.entries(priceObj.publicPriceByAge).forEach((entry) => {
            const [age, totalPrice] = entry
            service.setCrossPriceByAge(Number(age), (totalPrice as number * 100))
        })
    }


    private static fillTotalPricesByTravellerId(service: IParticipantService, quoteObj: ServiceQuote) {
        if (!quoteObj) throw new Error(`no quote data received for service ${service.getIdFull()}`)
        if (!quoteObj.travellers) return
        quoteObj.travellers.forEach((travellerObj: ServiceQuoteTravellerData) => {
            service.setTotalPriceByTravellerOrAccomodationId(travellerObj.id, travellerObj.price || 0)
        })
    }

}

export default ServiceFactory